import { render, staticRenderFns } from "./JobFairList.vue?vue&type=template&id=2a0b897e&scoped=true"
import script from "./JobFairList.vue?vue&type=script&lang=js"
export * from "./JobFairList.vue?vue&type=script&lang=js"
import style0 from "./JobFairList.vue?vue&type=style&index=0&id=2a0b897e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b897e",
  null
  
)

export default component.exports